import { Http } from '@/lib/http';

export class SecondaryAccountClassesService extends Http {
  constructor() {
    super();
    this.endpoint = 'gl/settings/secondary-account-classes';
  }

  createSecondaryAccountClass(payload) {
    return this.httpClient().post(`${this.endpoint}`, payload);
  }

  initializeDefaultDependencies() {
    return this.httpClient().post(`${this.endpoint}/defaults/initialize`);
  }

  fetchSecondaryAccountClasses() {
    return this.httpClient().get(`${this.endpoint}`);
  }

  updateSecondaryAccountClass(id, updates) {
    return this.httpClient().patch(`${this.endpoint}/${id}`, updates);
  }

  deleteSecondaryAccountClass(id) {
    return this.httpClient().delete(`${this.endpoint}/${id}`);
  }

}
